<template>
    <v-dialog
        v-model="dialog"
        max-width="90vw"
        persistent
    >
        <v-card
            height="90vh"
            style="position:relative;" 
            v-if="dialog"
        >                
            <iframe 
                ref="pdf" 
                style="width:100%; height:92%" 
                class="report-viewer"  
                :src="url"
            ></iframe>              
            <v-overlay
                absolute
                :value="overlay"
                color="white"
                opacity="0.60"
            >
                <!-- <v-progress-circular
                    indeterminate
                    size="64"
                    color="primary"
                ></v-progress-circular> -->
                <div class="loader"></div>
            </v-overlay>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="closeReport"
                    class="mr-2"
                >
                    Close Report
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> 
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex';

export default {
    name: 'PDFViewer',
    props: {
        src: String,
        openDialog: Boolean,
    },

    computed: {
        ...mapGetters({
            authToken: 'auth/getAuthToken'
        })    
    },

    mounted(){
        if(this.src == "" || this.src == null) return;
        this.openReport();
    },


    data: function() {
        return {
            dialog: this.openDialog,
            overlay: false,
            url: null,
        }
    },

    watch: {
        openDialog(val){
            if(val){
                this.dialog = true;
                console.log('opening dialog...');
                this.openReport();
            }
        }
    },

    methods: {
        async openReport() {
            this.overlay = true;
            axios.get(
                this.src,
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.authToken,
                        Accept: 'application/pdf'
                        }
                    }
            )
            .then(response => {
                const file = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                );
                this.url = URL.createObjectURL(file);
                this.overlay = false;
            })
            .catch(error => {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.overlay = false;
            });
        },
        closeReport() {
            this.dialog = false;
            this.url = null;
            this.$emit('closeReport');
        }
    }
}
</script>

<style scoped>
    /* HTML: <div class="loader"></div> */
    .loader {
    width: 40px;
    height: 20px;
    --c:no-repeat radial-gradient(farthest-side,#000 93%,#0000);
    background:
        var(--c) 0    0,
        var(--c) 50%  0;
    background-size: 8px 8px;
    position: relative;
    clip-path: inset(-200% -100% 0 0);
    animation: l6-0 1.5s linear infinite;
    }
    .loader:before {
    content: "";
    position: absolute;
    width: 8px;
    height: 12px;
    background: #000;
    left: -16px;
    top: 0;
    animation: 
        l6-1 1.5s linear infinite,
        l6-2 0.5s cubic-bezier(0,200,.8,200) infinite;
    }
    .loader:after {
    content: "";
    position: absolute;
    inset: 0 0 auto auto;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #000; 
    animation: l6-3 1.5s linear infinite;
    }
    @keyframes l6-0 {
    0%,30%  {background-position: 0  0   ,50% 0   }
    33%     {background-position: 0  100%,50% 0   }
    41%,63% {background-position: 0  0   ,50% 0   }
    66%     {background-position: 0  0   ,50% 100%}
    74%,100%{background-position: 0  0   ,50% 0   }
    }
    @keyframes l6-1 {
    90%  {transform:translateY(0)}
    95%  {transform:translateY(15px)}
    100% {transform:translateY(15px);left:calc(100% - 8px)}
    }
    @keyframes l6-2 {
    100% {top:-0.1px}
    }
    @keyframes l6-3 {
    0%,80%,100% {transform:translate(0)}
    90%         {transform:translate(26px)}
    }
</style>